import ApiService from '@/shared/services/api.service';
// import LocalApplicationsApiService from '@/shared/services/local-applications-api.service';

const ID_BATCH_SIZE = 50;

export class ApplicationTypeService {
    static list(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/application-types', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static create(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/application-types', { ...data } )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static update(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/application-types/${id}`, { ...data })
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static async remove(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/application-types/${id}`)
                .then(() => resolve())
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static find(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/application-types/${id}`)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => reject(error));
        });
    }

    static findBySeriesTypeIds(ids) {
        return new Promise((resolve, reject) => {
            // LocalApplicationsApiService.query('/application-types/by-series-types', {
            ApiService.query('/application-types/by-series-types', {
                params: { ids: ids.join(','), fields: ['name'] },
            })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    // Batches ids to keep query strings short and avoids one request per id
    static async findByIds(ids) {
        const uniqueIds = [...new Set(ids)].filter(Boolean);
        if (uniqueIds.length === 0) return [];

        const chunks = [];
        for (let i = 0; i < uniqueIds.length; i += ID_BATCH_SIZE) {
            chunks.push(uniqueIds.slice(i, i + ID_BATCH_SIZE));
        }

        const results = [];
        for (const chunk of chunks) {
            const response = await ApiService.query('/application-types', {
                params: { query: `_id in ${chunk.join(',')}`, limit: chunk.length, pagination: true },
            });
            results.push(...(response?.data?.data || response?.data || []));
        }

        return results;
    }

    static upload(token, files) {
        return new Promise((resolve, reject) => {
           ApiService.post('/files?echo=true', files, {
               'content-type': 'multipart/form-data',
               'x-file-access-token': token,
           })
               .then((response) => resolve(response.data))
               .catch((error) => reject(error));
        });
    }

    static async listAutocomplete() {
        const response = await ApiService.get('/application-types');
        return response?.data?.data || [];
    }
}
